export enum AvatarIconIdentifierEnum {
  // Technisch en onderhoud
  Tools = "tools",
  Wrench = "wrench",
  Gears = "gears",
  Brush = "brush",

  // Groenvoorziening
  Leaf = "leaf",
  Seedling = "seedling",
  Tree = "tree",
  Tractor = "tractor",
  Shovel = "shovel",

  // Kantoor & receptie
  Headset = "headset",
  Phone = "phone",
  InfoCircle = "info-circle",
  BellConcierge = "bell-concierge",
  CalendarDays = "calendar-days",

  // Schoonmaken
  Broom = "broom",
  Soap = "soap",
  SprayCan = "spray-can",
  Tshirt = "tshirt",
  HandSparkles = "hand-sparkles",

  // Beveiliging & gezondheidsdiensten
  FirstAid = "first-aid",
  ShieldAlt = "shield-alt",
  FaceMask = "face-mask",
  FireExtinguisher = "fire-extinguisher",

  // Zwembad
  Water = "water",
  Swimmer = "swimmer",
  SwimmingPool = "swimming-pool",
  TemperatureList = "temperature-list",

  // Bezorgdiensten / Inbrengservice
  Truck = "truck",
  Box = "box",
  Dolly = "dolly",

  // Horeca
  Coffee = "coffee",
  Utensils = "utensils",
  Hamburger = "hamburger",
  IceCream = "ice-cream",

  // Animatie & recreatie
  Person = "person",
  Smile = "smile",
  TheaterMasks = "theater-masks",
  Volleyball = "volleyball",
}
